const $ = window.jQuery;


const vCard = {

    init() {
        const $module = $('.download-contact');
        if (!$module.length)
            return;
 
        
        $module.on('click', function() {
            const id = $(this).attr('data-id');

            if (id) {
                window.location = femp.home_url + '/vcard-generator?id=' + id;
            }
        })
      

    },
    genVCard() {
        const start = "BEGIN:VCARD\nVERSION:3.0";
        const end = "END:VCARD";
        let data = "";

        const init = function () {
            data = "";
        };

        const name = function (surname, lastname) {
            data += "N:" + lastname + ';' + surname;
            data += "\n";
        };

        const cell = function (cell) {
            data += "TEL;TYPE=CELL:" + cell;
            data += "\n";
        };

        const work = function (work) {
            data += "TEL;TYPE=WORK,VOICE:" + work;
            data += "\n";
        };

        const other = function (work) {
            data += "TEL;TYPE=OTHER:" + work;
            data += "\n";
        };

        const email = function (email) {
            data += "EMAIL;TYPE=PREF,INTERNET:" + email;
            data += "\n";
        };

        const get = function () {
            return start + '\n' + data + end;
        };

        return {
            init: init,
            name: name,
            cell: cell,
            work: work,
            other: other,
            email: email,
            get: get
        }
    }

};

export default vCard;